import { Button } from '@/components/shadcn/button';
import { Header } from '@/components/compound-components/header';
import { useEffect } from 'react';
import { logError } from '@/lib/rum';
import { env } from 'next-runtime-env';

export const ErrorOccurredPage = () => {
  useEffect(() => {
    logError('An error occurred.');
  }, []);

  return (
    <>
      <Header />
      <div className='flex flex-col items-center justify-center pt-24'>
        <h1>Something went wrong</h1>
        <div className='mt-12 text-2xl'>{`We're looking into it. We recommend starting again from Home.`}</div>
        <Button
          className='mt-10'
          onClick={() => {
            window.location.href = env('WEBSITE') || '/';
          }}
        >
          Home
        </Button>
      </div>
    </>
  );
};
